module.exports = __webpack_public_path__ + "static/media/shape1_7.0e318b9f.obj";